'use strict';

export default class ResetPasswordController {
  user = {
    newPassword: '',
    confirmPassword: ''
  };
  errors = {
    other: undefined
  };
  message = '';
  submitted = false;

  passwordResetSuccess = false;
  passwordResetExpired = false;

  /*@ngInject*/
  constructor(Auth, $stateParams) {
    this.Auth = Auth;
    this.id = $stateParams.id;
    this.token = $stateParams.token;
  }

  submit(form) {
    this.submitted = true;

    this.passwordResetExpired = false;
    this.passwordResetSuccess = false;

    if(form.$valid) {
      this.Auth.resetPassword(this.id, this.token, this.user.newPassword)
        .then(() => {
          this.passwordResetSuccess = true;
        })
        .catch(() => {
          this.passwordResetExpired = true;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/reset-password/reset-password.controller.js